import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { Sanitizer } from "./util/sanitizer";
import { custom } from "./util/inspect";
var errorSanitizer = new Sanitizer();
/**
 * An error resulting from an HTTP request to a service endpoint.
 */

export var RestError = /*#__PURE__*/function (_Error) {
  _inherits(RestError, _Error);

  function RestError(message, code, statusCode, request, response) {
    var _this;

    _classCallCheck(this, RestError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RestError).call(this, message));
    _this.name = "RestError";
    _this.code = code;
    _this.statusCode = statusCode;
    _this.request = request;
    _this.response = response;
    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this)), RestError.prototype);
    return _this;
  }
  /**
   * Logging method for util.inspect in Node
   */


  _createClass(RestError, [{
    key: custom,
    value: function value() {
      return "RestError: ".concat(this.message, " \n ").concat(errorSanitizer.sanitize(this));
    }
  }]);

  return RestError;
}(_wrapNativeSuper(Error));
/**
 * A constant string to identify errors that may arise when making an HTTP request that indicates an issue with the transport layer (e.g. the hostname of the URL cannot be resolved via DNS.)
 */

RestError.REQUEST_SEND_ERROR = "REQUEST_SEND_ERROR";
/**
 * A constant string to identify errors that may arise from parsing an incoming HTTP response. Usually indicates a malformed HTTP body, such as an encoded JSON payload that is incomplete.
 */

RestError.PARSE_ERROR = "PARSE_ERROR";